import d from "../../node_modules/classnames/index.js";
import { forwardRef as l } from "react";
import "./UIInputTextArea2.js";
import { jsx as n } from "../../_virtual/jsx-runtime.js";
const h = l(({
  hasError: e,
  name: t,
  className: r,
  disabled: a,
  maxLength: m,
  onBlur: o,
  onChange: s,
  placeholder: i,
  value: p,
  rows: x = 2,
  size: f = "medium"
}, u) => /* @__PURE__ */ n("textarea", {
  ref: u,
  "data-error": e,
  maxLength: m,
  disabled: a,
  placeholder: i,
  rows: x,
  "data-size": f,
  className: d("input-text-area", "shakeable", {
    "input-text-area--disabled": a
  }, r),
  name: t,
  value: p || "",
  onBlur: o,
  onChange: s
}));
export {
  h as UIInputTextArea
};
//# sourceMappingURL=UIInputTextArea.js.map
